"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SmokingSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M15,11 L15,14 L3,14 L3,11 L15,11 Z M12,11.9990557 L4,12 L4,13 L12,12.9990557 L12,11.9990557 Z M14,12 L13,11.9990557 L13,12.9990557 L14,13 L14,12 Z M13.5,6 C14.2796961,6 14.9204487,6.59488808 14.9931334,7.35553999 L15,7.5 L15,10 L14,10 L14,7.5 C14,7.25454011 13.8231248,7.05039163 13.5898756,7.00805567 L13.5,7 L13,7 L13,6 L13.5,6 Z M13,3.00705569 L13,4.00705569 C11.9182886,4.00705569 10.9817878,4.83212036 10.9817878,6 C10.9817878,6.79368584 11.4613864,7.43312808 12.50164,7.94340535 L12.7032775,8.03757481 L13,8.1696135 L13,10 L12,10 L12,8.809 L11.86476,8.7398898 C10.7014979,8.11402312 10.055944,7.2580947 9.98780607,6.19057796 L9.98178782,6 C9.98178782,4.31216581 11.2932693,3.09646031 12.8285478,3.01177705 L13,3.00705569 Z" })));
};
SmokingSmall.displayName = 'SmokingSmall';
exports.default = SmokingSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SmokingSmall.js.map